const PORTRAIT_IMG = "https://static.prod-images.emergentagent.com/jobs/fa271865-0df8-4fa8-8742-040f1c30ae47/images/7b41c34c5c0beb3ea3953a4181a045900f0d5c85bb7a6a0be3057431b7392c4c.png";

export default function MissionSection() {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-3">Why BBAP exists</p>
          <h2 className="font-display font-extrabold uppercase text-3xl md:text-4xl text-zinc-950 tracking-tight mb-5">
            An everyday emergency
          </h2>
          <p className="text-zinc-600 leading-relaxed mb-4">
            BBAP exists because of a single, unbroken thread: 57 years of watching bias operate up close —
            not as an idea, but as something lived. I'll be transparent for a moment — a true story:
          </p>
          <blockquote className="border-l-4 border-[#4FD1C5] pl-5 italic text-zinc-700 leading-relaxed mb-4">
            "I remember being a child, kicked in the back at a public swimming pool by grown men — for no
            reason other than the color of my skin. That memory hasn't faded. Decades later, the scar
            remains."
          </blockquote>
          <p className="text-zinc-600 leading-relaxed mb-4">
            That's just one moment, out of one lifetime, from one person. The fact is, most so-called Black
            people raised in predominantly non-Black environments carry some version of that same file —
            moments where you were treated as a threat, a suspect, or simply less-than, by adults who should
            have known better, long before you were old enough to understand why.
          </p>
          <p className="text-zinc-600 leading-relaxed mb-4">
            It didn't stop at childhood. It followed into adulthood — into workplaces, stores, neighborhoods,
            doctor's offices, your own property or luxury condo — anywhere trust is supposed to be a
            given, and instead has to be earned over and over again. That accumulation is the real story: not
            one incident, but a lifetime of them, stacked. This has become a way of life that, quite frankly,
            needs to be challenged and changed.
          </p>
          <p className="text-zinc-600 leading-relaxed mb-4">
            We live in a country that promises freedom and justice for all, yet how someone is treated in
            public still depends far too often on how they look. When bias becomes systemic and ongoing, it
            carries a real, documented mental health cost — and we're building the systems to name that cost
            and connect people to real support.
          </p>
          <p className="text-zinc-950 font-semibold leading-relaxed mb-4">
            Our mission: equality, evolution, and safety for everyone.
          </p>
          <p className="text-[#1E3A6E] font-bold leading-relaxed">
            Join us, and be a part of the change.
          </p>
        </div>
        <div className="relative">
          <div className="rounded-sm w-full h-[420px] border border-bbap-border bg-zinc-100 flex items-center justify-center overflow-hidden">
            <img src={PORTRAIT_IMG} alt="BBAP founder" className="max-h-full max-w-full object-contain" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white border border-zinc-200 rounded-sm p-5 max-w-xs shadow-lg hidden sm:block">
            <p className="text-sm text-zinc-700 italic">"Bias is behavior. Behavior can be documented. Documented behavior becomes data. Data becomes accountability."</p>
          </div>
        </div>
      </div>
    </section>
  );
}
